import "./PrivacyPolicy.css";
import { VERSION } from "../../constants";
import Breadcrums from "../../components/breadcrums/Breadcrums";
import Breadcrumsv2 from "../../components/breadcrums_v2/Breadcrums";

const BreadcrumsDynamic = VERSION === "1" ? Breadcrums : Breadcrumsv2;

const PrivacyPolicy = () => {
  return (
    <div className="privacypolicy">
      <BreadcrumsDynamic />

      <div className="privacypolicy-content">
        <div className="pp-subtitle">1. INTRODUCTION</div>
        <div className="pp-descrip">
          <strong>1.1</strong> - Welcome to the Unity Platform run by Unity
          Malaysia Sdn Bhd (Company Registration No. 202101009013 [1409312-K])
          and its affiliates (individually and collectively, “Unity”, “we”, “us”
          or “our”). Unity takes its responsibilities under applicable privacy
          laws and regulations (“Privacy Laws”) seriously and is committed to
          respecting the privacy rights and concerns of all Users of our Unity
          website and mobile application (the “Platform”) (we refer to the
          Platform and the services we provide as described on our Platform
          collectively as the “Services”). Users refers to a user who registers
          for an account with us for use of the Services, including both buyers
          and sellers (individually and collectively, “Users”, “you” or “your”)
          We recognize the importance of the personal data you have entrusted to
          us and believe that it is our responsibility to properly manage,
          protect and process your personal data. This Privacy Policy (“Privacy
          Policy” or “Policy”) is designed to assist you in understanding how we
          collect, use, disclose and/or process the personal data you have
          provided to us and/or we possess about you, whether now or in the
          future, as well as to assist you in making an informed decision before
          providing us with any of your personal data. Please read this Privacy
          Policy carefully. If you have any questions regarding this information
          or our privacy practices, kindly refer to the section entitled
          “Questions, Concerns or Complaints? Contact Us” at the end of this
          Privacy Policy.
        </div>
        <div className="pp-descrip">
          <strong>1.2</strong> - “Personal Data” or “personal data” means data,
          whether true or not, about an individual who can be identified from
          that data, or from that data and other information to which an
          organisation has or is likely to have access. Common examples of
          personal data could include name, identification number and contact
          information.
        </div>
        <div className="pp-descrip">
          <strong>1.3</strong> - By using the Services, registering for an
          account with us, visiting our Platform, or accessing the Services, you
          acknowledge and agree that you accept the practices, requirements,
          and/or policies outlined in this Privacy Policy, and you hereby
          consent to us collecting, using, disclosing and/or processing your
          personal data as described herein. IF YOU DO NOT CONSENT TO THE
          PROCESSING OF YOUR PERSONAL DATA AS DESCRIBED IN THIS PRIVACY POLICY,
          PLEASE DO NOT USE OUR SERVICES OR ACCESS OUR PLATFORM. If we change
          our Privacy Policy, we will notify you including by posting those
          changes or the amended Privacy Policy on our Platform. We reserve the
          right to amend this Privacy Policy at any time. To the fullest extent
          permissible under applicable law, your continued use of the Services
          or Platform, including placing of any orders, shall constitute your
          acknowledgement and acceptance of the changes made to this Privacy
          Policy.
        </div>
        <div className="pp-descrip">
          <strong>1.4</strong> - with other notices, contractual clauses,
          consent clauses that apply in relation to the collection, storage,
          use, disclosure and/or processing of your personal data by us and is
          not intended to override those notices or clauses unless we state
          expressly otherwise.
        </div>
        <div className="pp-descrip">
          <strong>1.5</strong> - This Policy applies to both buyers and sellers
          who use the Services except where expressly stated otherwise.
        </div>

        <div className="pp-subtitle">
          2. WHEN WILL UNITY COLLECT PERSONAL DATA?
        </div>
        <div className="pp-descrip">
          <strong>2.1</strong> - We will/may collect personal data about you:
          <br />
          (a) When you register and/or use our Services or Platform, or open an
          account with us;
          <br />
          (b) When you submit any form, including, but not limited to,
          application forms or other forms relating to any of our products and
          services, whether online or by way of a physical form;
          <br />
          (c) When you enter into any agreement or provide other documentation
          or information in respect of your interactions with us, or when you
          use our products and services;
          <br />
          (d) When you enter into any agreement or provide other documentation
          or information in respect of your interactions with us, or when you
          use our products and services;
          <br />
          (e) When you use our electronic services or interact with us via
          application or use Services on our Website. This includes, without
          limitation, through cookies which we may deploy when you interact with
          our application website;
          <br />
          (f) When you grant permissions on your device to share information
          with our application or platform;
          <br />
          (g) When you link your Unity account with your social media or other
          external account or use other social media features, in accordance
          with the provider's policies.
          <br />
          (h) When you carry out transactions through our Services;
          <br />
          (i) When you provide us with feedback or complaints;
          <br />
          (j) When you register for a contest or campaign; or
          <br />
          (k) When you submit your personal data to us for any reason.
        </div>
        <div className="pp-descrip">
          The above does not purport to be exhaustive and sets out some common
          instances of when personal data about you may be collected.
        </div>

        <div className="pp-subtitle">
          3. WHAT PERSONAL DATA WILL UNITY COLLECT?
        </div>
        <div className="pp-descrip">
          <strong>3.1</strong> - The personal data that Unity may collect
          includes but is not limited to:
          <ul className="pp-list">
            <li>Company information;</li>
            <li>Email address;</li>
            <li>Billing and/or delivery address;</li>
            <li>Online store;</li>
            <li>Bank account and payment information;</li>
            <li>Telephone number;</li>
            <li>
              Information sent by or associated with the device(s) used to
              access our Services or Platform;
            </li>
            <li>
              Information about your network and the people and accounts you
              interact with;
            </li>
            <li>
              Government issued identification or other information required for
              our due diligence, know your customer, identity verification, or
              fraud prevention purposes;
            </li>
            <li>
              Marketing and communications data, such as your preferences and
              history marketing from us and third parties, your communication
              preferences and history of communications with us, our service
              providers, and other third parties;
            </li>
            <li>
              Usage and transaction data, including details about your searches,
              orders, the advertising and content you interact with on the
              Platform, and other products and services related to you;
            </li>
            <li>Location data;</li>
            <li>
              Any other information about the User when the User signs up to use
              our Services or Platform, and when the Users uses the Services or
              Platform, as well as information related to how the User uses our
              Services or Platform; and
            </li>
            <li>Aggregate data on content the User engages with.</li>
          </ul>
        </div>
        <div className="pp-descrip">
          <strong>3.2</strong> - You agree not to submit any information to us
          which is inaccurate or misleading, and you agree to inform us of any
          inaccuracies or changes to such information. We reserve the right at
          our sole discretion to require further documentation to verify the
          information provided by you.
        </div>
        <div className="pp-descrip">
          <strong>3.3</strong> - If you sign up to be a user of our Platform
          using your social media account (“Social Media Account”), link your
          Unity account to your Social Media Account or use any Unity social
          media features, we may access information about you which you have
          voluntarily provided to your Social Media Account provider in
          accordance with such provider's policies, and we will manage and use
          any such personal data in accordance with this Policy at all times.
        </div>
        <div className="pp-descrip">
          <strong>3.4</strong> - If you do not want us to collect the
          aforementioned information/personal data, you may opt out at any time
          by notifying our Officer in writing about it. Further information on
          opting out can be found in the section below entitled “How can you
          opt-out, remove, request access to or modify information you have
          provided to us ?”. Note, however, that opting out of us collecting
          your personal data or withdrawing your consent for us to collect, use
          or process your personal data may affect your use of the Services. For
          example, opting out of the collection of location information will
          cause its location-based features to be disabled.
        </div>

        <div className="pp-subtitle">4. COLLECTION OF OTHER DATA</div>
        <div className="pp-descrip">
          <strong>4.1</strong> - As with most websites and mobile applications,
          your device sends information which may include data about you that
          gets logged by a web server when you browse our Platform. This
          typically includes without limitation your device's Internet Protocol
          (IP) address, computer/mobile device operating system and browser
          type, type of mobile device, the characteristics of the mobile device,
          the unique device identifier (UDID) or mobile equipment identifier
          (MEID) for your mobile device, the address of a referring web site (if
          any), the pages you visit on our website and mobile applications and
          the times of visit, and sometimes a “cookie” (which can be disabled
          using your browser preferences) to help the site remember your last
          visit. If you are logged in, this information is associated with your
          personal account. The information is also included in anonymous
          statistics to allow us to understand how visitors use our site.
        </div>
        <div className="pp-descrip">
          <strong>4.2</strong> - Our mobile applications may collect precise
          information about the location of your mobile device using
          technologies such as GPS, Wi-Fi, etc. We collect, use, disclose and/or
          process this information for one or more Purposes including, without
          limitation, location-based services that you request to deliver
          relevant content to you based on your location or to allow you to
          share your location to other Users as part of the services under our
          mobile applications. For most mobile devices, you are able to withdraw
          your permission for us to acquire this information on your location
          through your device settings. If you have questions about how to
          disable your mobile device's location services, please contact your
          mobile device service provider or the device manufacturer.
        </div>
        <div className="pp-descrip">
          <strong>4.3</strong> - As when you view pages on our website or mobile
          application, when you watch content and advertising and access other
          software on our Platform or through the Services, most of the same
          information is sent to us (including, without limitation, IP Address,
          operating system, etc); but, instead of page views, your device sends
          us information on the content advertisement viewed and/or software
          installed by the Services and the Platform and time.
        </div>

        <div className="pp-subtitle">5. COOKIES</div>
        <div className="pp-descrip">
          <strong>5.1</strong> - We or our authorised service providers and
          advertising partners may from time-to-time use “cookies” or other
          features to allow us or third parties to collect or share information
          in connection with your use of our Services or Platform. These
          features help us to improve our Platform and the Services we offer,
          help us offer new services and features, and/or enable us and our
          advertising partners serve more relevant content to you, including
          through remarketing. “Cookies” are identifiers that are stored on your
          computer or device that record data about your computer or device, by
          how many people and other activity within our Platform. We may link
          cookie information to personal data. Cookies also link to information
          regarding what items you have selected for purchase and web pages you
          have viewed. This information is used to keep track of your shopping
          cart, to deliver content specific to your interests, to enable our
          third-party advertising partners to serve advertisements on sites
          across the internet and to conduct data analysis and to monitor usage
          of the Services.
        </div>
        <div className="pp-descrip">
          <strong>5.2</strong> - You may refuse the use of cookies by selecting
          the appropriate settings on your browser or device. However, please
          note that if you do this you may not be able to use the full
          functionally of our Site or the Services.
        </div>

        <div className="pp-subtitle">
          6. HOW DO WE USE THE INFORMATION YOU PROVIDE US?
        </div>
        <div className="pp-descrip">
          <strong>6.1</strong> - We may collect, use, disclose and/or process
          your personal data for one or more of the following purposes:
          <br />
          (a) To consider and/or process your application/transaction with us or
          your transactions or communications with third parties via the
          Services;
          <br />
          (b) To manage, operate, provide and/or administer your use of and/or
          access to our Services and our Website, as well as your relationship
          and user account with us;
          <br />
          (c) To manage, operate, administer and provide you with as well as to
          facilitate the provision of our Services, including, without
          limitation, remembering your preferences;
          <br />
          (d) To tailor your experience through the Services by displaying the
          content according to your interests and preferences, providing a
          faster method for you to access your account and submit information to
          us and allowing us to contact you, if necessary;
          <br />
          (e) To respond, to process, deal with or complete a transaction and/or
          to fulfil your requests for certain products and services and notify
          you of service issues and unusual account
          <br />
          (f) To enforce our Terms of Service or any applicable end user license
          agreements;
          <br />
          (g) To protect personal safety and the rights, property or safety of
          others;
          <br />
          (h) For identification, verification, due diligence or know your
          customer purposes
          <br />
          (i) To maintain and administer any software updates and/or other
          updates and support that may be required from time to time to ensure
          the smooth running of our Services;
          <br />
          (j) To deal with or facilitate customer service, carry out your
          instructions, deal with or respond to any enquiries given by (or
          purported to be given by) you or on your behalf;
          <br />
          (k) To contact you or communicate with you via voice call, text
          message and/or fax message, email and/or postal mail or otherwise for
          the purposes of administering and/or managing your relationship with
          us or your use of our Services, such as but not limited to
          communicating administrative information to you relating to our
          Services. You acknowledge and agree that such communication by us
          could be by way of the mailing of correspondence, documents or notices
          to you, which could involve disclosure of certain personal data about
          you to bring about delivery of the same as well as on the external
          cover of envelopes/mail packages;
          <br />
          (l) To conduct research, analysis and development activities
          (including, but not limited to, data analytic, surveys, product and
          service development and/or profiting), to analyse how you use our
          Services, to recommend products and/or services relevant to your
          interest, to improve our Services or products and/or to enhance your
          customer experience;
          <br />
          (m) To allow for audits and surveys to, among other things, validate
          the size and composition of our target audience, and understand their
          experience with Unity's Services;
          <br />
          (n) For marketing and advertising, and in this regard, to send you by
          various mediums and modes of communication marketing and promotional
          information and materials relating to products and/or services
          (including, without limitation, products and/or services of third
          parties whom Unity may collaborate or tie up with) that Unity (and/or
          its affiliates or related corporations) may be selling, marketing or
          promoting, whether such products or services exist now or are created
          in the future. You can unsubscribe function within the electronic
          marketing material. We may use your contact information to send
          newsletters or marketing materials from us and from our related
          companies;
          <br />
          (o) To respond to legal processes or to comply with or as required by
          any applicable law, governmental or regulatory requirements of any
          relevant jurisdiction, or where we have a good faith belief that such
          disclosure is necessary, including, without limitation, meeting the
          requirements to make disclosure under the requirements of any law
          binding on Unity or its related corporations or affiliates (including
          where applicable, the display of your name, contact details and
          company details)
          <br />
          (p) To produce statistics and research for internal and statutory
          reporting and/or record-keeping requirements;
          <br />
          (q) To carry out due diligence or other screening activities
          (including, without limitation, background checks) in accordance with
          legal or regulatory obligations or our risk management procedures that
          may be required by law or that may have been put in place by us;
          <br />
          (r) To audit our Services or Unity's business;
          <br />
          (s) To prevent or investigate any actual or suspected violations of
          our Terms of Service, fraud, unlawful activity, omission or
          misconduct, whether relating to your use of our Services or any other
          matter arising from your relationship with us.
          <br />
          (t) To respond to any threatened or actual claims asserted against
          Unity or other claim that any Content violates the rights of third
          parties;
          <br />
          (u) To store, host, back up (whether for disaster recovery or
          otherwise) of your personal data, whether within or outside of your
          jurisdiction;
          <br />
          (v) To deal with and/or facilitate a business asset transaction or a
          potential business asset transaction, where such transaction involves
          Unity as a participant or involves only a related corporation or
          affiliate of Unity as a participant or involves Unity and/or any one
          or more of Unity’s related corporations or affiliates as
          participants(s), and there may be other third-party organisations who
          are participants in such transaction. A “business asset transaction”
          refers to the purchase, sale, lease, merger, amalgamation or any other
          acquisition, disposal or financing of an organisation or a portion of
          an organisation or any of the business or assets of an organisation
          and/or
          <br />
          (w) Any other purposed which we notify you of at the time of obtaining
          your consent.
        </div>
        <div className="pp-descrip">(Collectively, the “Purposes”).</div>
        <div className="pp-descrip">
          <strong>6.2</strong> - You acknowledge, consent and agree that Unity
          may access, preserve and disclose your Account information and Content
          if required to do so by law or pursuant to an order of a court or by
          any governmental or regulatory authority having jurisdiction over
          Unity or in a good faith belief that such access preservation or
          disclosure is reasonably necessary to : (a) comply with legal process;
          (b) comply with a request from any governmental or regulatory
          authority having jurisdiction over Unity; (c) enforce the Unity Terms
          of Services or other Privacy Policy; (d) respond to any threatened or
          actual claims asserted against Unity or other claim that any Content
          violates the rights of third parties; (e) Respond to your request for
          customer service; or (f) protect the rights, property of your personal
          safety of Unity, its users and/or the public.
        </div>
        <div className="pp-descrip">
          <strong>6.3</strong> - As the purposes for which we will/may collect,
          use, disclose or process your personal data depend on the
          circumstances at hand, such purpose may not appear above. However, we
          will notify you of such other purpose at the time of obtaining your
          consent, unless processing of the applicable data without your consent
          is permitted by the Privacy Laws.
        </div>

        <div className="pp-subtitle">
          7. HOW DOES UNITY PROTECT AND RETAIN CUSTOMER INFORMATION?
        </div>
        <div className="pp-descrip">
          <strong>7.1</strong> - We implement a variety of security measures and
          strive to ensure the security of your personal data on our systems.
          User personal data is contained behind secured networks and is only
          accessible by a limited number of employees who have special access
          rights to such systems. However, there can inevitably be no guarantee
          of absolute security.
        </div>
        <div className="pp-descrip">
          <strong>7.2</strong> - We will retain personal data in accordance with
          the Privacy Laws and/or other applicable laws. That is, we will
          destroy or anonymize your personal data as soon as it is reasonable to
          assume that (i) the purpose for which that personal data was collected
          is no longer being served by the retention of such personal data; and
          (ii) retention is no longer necessary for any legal or business
          purposes. If you cease using the Site, or your permission to use the
          Site and/or the Services is terminated or withdrawn, we may continue
          storing, using and/or disclosing your personal data in accordance with
          this Privacy Policy and our obligations under the Privacy Laws.
          Subject to applicable law, we may securely dispose of your personal
          data without prior notice to you.
        </div>

        <div className="pp-subtitle">
          8. DOES UNITY DISCLOSE THE INFORMATION IT COLLECTS FROM ITS VISITORS
          TO OUTSIDE PARTIES?
        </div>
        <div className="pp-descrip">
          <strong>8.1</strong> - In conducting our business, we will/may need to
          disclose your personal data to our third-party service providers,
          agents and/or our affiliates or related corporations, and/or other
          third parties, whether sited in Malaysia or outside of Malaysia, for
          one or more of the above-stated Purposes. Such third-party service
          providers, agents and/or affiliates or related corporations and/or
          other parties would be processing your personal data either on our
          behalf or otherwise, for one or more of the above-stated Purposes.
          Such third-parties include, without limitation:
          <br />
          (a) Our subsidiaries, affiliates and related corporations;
          <br />
          (b) Buyers or sellers you have transacted with or interacted with on
          the Platform or in connection with your use of the Services for the
          above-stated Purposes
          <br />
          (c) Other users of our Platform for one or more of the above-stated
          Purposes;
          <br />
          (d) Contractors, agents, service providers and other third-parties we
          use to support our business. These include but are not limited to
          those parties which provide administrative or other services to us
          such as mailing houses, logistics services providers, financial
          services providers, advertising and marketing partners,
          telecommunication companies, information technology companies and data
          centres;
          <br />
          (e) Governmental or regulatory authorities having jurisdiction over
          Unity or as otherwise permitted under Section 6.2;
          <br />
          (f) A buyer or other successor in the event of a merger, divestiture,
          restructuring, reorganization, dissolution or other sale or transfer
          of some or all Unity's assets, whether as a going concern or as part
          of bankruptcy, liquidation or similar proceeding, in which personal
          data held by Unity about our Service Users is among the assets
          transferred; or to a counterparty in a business asset transaction that
          Unity or any of its affiliates or related corporations is involved in;
          and
          <br />
          (g) Third-parties to whom disclosure by us is for one or more of the
          Purposes and such third-parties would in turn be collecting and
          processing your personal data for one or more of the Purposes
        </div>
        <div className="pp-descrip">
          <strong>8.2</strong> - We may share user information including
          statistical and demographic information about our Users and
          information about their use of the Services with advertising partners
          and third-party suppliers of advertisements, remarketing and/or other
          programming.
        </div>
        <div className="pp-descrip">
          <strong>8.3</strong> - For the avoidance of doubt, in the event that
          Privacy Laws or other applicable laws permit an organisation such as
          us to collect, use or disclose your personal data without your
          consent, such permission granted by the laws shall continue to apply.
          Consistent with the foregoing and subject to applicable law, we may
          use your personal data for recognised legal grounds including to
          comply with our legal obligations to perform our contract with you, to
          achieve a legitimate interest and our reasons for using it outweigh
          any prejudice to your data protection rights, or where necessary in
          connection with a legal claim.
        </div>
        <div className="pp-descrip">
          <strong>8.4</strong> - Third-parties may unlawfully intercept or
          access personal data transmitted to or contained on the site,
          technologies may malfunction or not work as anticipated, or someone
          might access, abuse or misuse information through no fault of ours. We
          will nevertheless deploy reasonable security arrangements to protect
          your personal data as required by the Privacy Laws; however, there can
          inevitably be no guarantee of absolute security such as but not
          limited to when unauthorised disclosure arises from malicious and
          sophisticated hacking by malcontents through no fault of ours.
        </div>
        <div className="pp-descrip">
          <strong>8.5</strong> - As set forth in Unity's Terms of Services, user
          in possession of another User's personal data through the use of the
          Services (the “Receiving Party”) hereby agree that, they will (i)
          comply with all applicable personal data protection laws with respect
          to any such data; (ii) allow the User whose personal data the
          Receiving Party has collected (the “Disclosing Party”) to remove his
          or her data so collected from the Receiving Party's database; and
          (iii) allow the Disclosing Party to review what information has been
          collected about them by the Receiving Party, in each case of (ii) and
          (iii) above, in compliance with and where required by applicable laws.
        </div>
        <div className="pp-descrip">
          <strong>8.6</strong> - Notwithstanding anything set forth herein,
          Sellers shall comply with all applicable Privacy Laws and, in respect
          of any buyer's personal data received from Unity, (i) are not
          permitted to use such buyer's personal data except as reasonably
          necessary to respond to buyers' enquiries and to carry out respond to,
          process, deal with or complete a transaction without buyers' and
          Unity's prior written consent; (ii) should refrain from contacting
          buyers using such information outside of the Unity platform. (iii) are
          not permitted to disclose such buyer's personal data to unauthorised
          third-parties without buyer's and Unity's prior written consent; (iv)
          shall employ sufficient security measures to protect each Unity user's
          personal data in their possession and to delete such data as soon as
          reasonably possible upon completion of the transaction; and (v) to
          inform Unity's Personal Data Officer at customerservice@unity.net.my
          in the event of any potential data breach or other loss of such user's
          data.
        </div>

        <div className="pp-subtitle">
          9. INFORMATION COLLECTED BY THIRD-PARTIES?
        </div>
        <div className="pp-descrip">
          <strong>9.1</strong> - Our Site uses Google Analytics, a web analytics
          service provided by Google, Inc. (“Google”). Google Analytics uses
          cookies, which are text files placed on your computer, to help the
          website analyse how Users use the Site. The information generated by
          the cookie about your use of the website (including your IP address)
          will be transmitted to and store by Google on services in the United
          States. Google will use this information for the purpose of evaluating
          your use of the website, compiling reports on website activity for
          website operators and providing other services relating to website
          activity and internet usage. Google may also transfer this information
          to third-parties where required to do so by law, or where such
          third-parties process information on Google's behalf. Google will not
          associate your IP address with any other data held by Google. Similar
          code found with
        </div>
        <div className="pp-descrip">
          <strong>9.2</strong> - We, and third-parties, may from time to time
          make software applications downloads available for your use on or
          through the Services. These applications may separately access, and
          allow a third party to view, your identifiable information, such as
          your name, your user ID, your computer's IP address or other
          information such as any cookies that you may previously have installed
          or that were installed for you by a third-party software application
          or website. Additionally, these applications may ask you to provide
          additional information directly to third-parties. Third-party products
          or services provided through these applications are not owned or
          controlled by Unity. You are encouraged to read the terms and other
          policies published by such third parties on their website or
          otherwise.
        </div>

        <div className="pp-subtitle">
          10. DISCLAIMER REGARDING SECURITY AND THIRD-PARTY SITES
        </div>
        <div className="pp-descrip">
          <strong>10.1</strong> - WE DO NOT GUARANTEE THE SECURITY OF PERSONAL
          DATA AND/OR OTHER INFORMATION THAT YOU PROVIDE ON THIRD PARTY SITES.
          We do implement a variety of security measures to maintain the safety
          of your personal data that is in our possession or under our control.
          Your personal data is contained behind secured networks and is only
          accessible by a limited number of persons who have special access
          rights to such systems, and are required to keep the personal data
          confidential. When you place orders or access your personal data, we
          offer the use of a secure server. All personal data or sensitive
          information you supply is encrypted into our databases to be only
          accessed as stated above.
        </div>
        <div className="pp-descrip">
          <strong>10.2</strong> - In an attempt to provide you with increased
          value, we may choose various third-party websites to link to, and
          frame within the Site. We may also participate in co-branding and
          other relationships to offer e-commerce and other services and
          features to our visitors. These linked sites have separate and
          independent privacy policies as well as security arrangements. Even if
          the third party is affiliated with us, we have no control over these
          linked sites, each of which has separate privacy and data collection
          practices independent of us. Data collected by our co-brand partners
          or third-party websites (even if offered on or through our Site) may
          not be received by us.
        </div>
        <div className="pp-descrip">
          <strong>10.3</strong> - We therefore have no responsibility or
          liability for the content security arrangements (or lack thereof) and
          activities of these linked sites. These linked sites are only for your
          convenience and your therefore access them at your own risk.
          Nonetheless, we seek to protect the integrity of our Site and the
          links placed upon each of them and therefore welcome any feedback
          about these linked sites (including without limitations, if a specific
          link does not work).
        </div>

        <div className="pp-subtitle">
          11. WILL UNITY TRANSFER YOUR INFORMATION OVERSEAS?
        </div>
        <div className="pp-descrip">
          Your personal data and/or information may be transferred to, stored or
          processed outside of your country. In most cases, your personal data
          will be processed in Malaysia, where our servers are located. Unity
          will only transfer your information overseas in accordance with
          Privacy Laws.
        </div>

        <div className="pp-subtitle">
          12. HOW CAN YOU WITHDRAW CONSENT, REQUEST ACCESS TO OR CORRECT
          INFORMATION YOU HAVE PROVIDED TO US?
        </div>
        <div className="pp-descrip">
          <strong>12.1</strong> - Withdrawing Consent
        </div>
        <div className="pp-descrip">
          <strong>12.1.1</strong> - You may withdraw your consent for the
          collection, use and and/or disclosure of your personal data in our
          possession or under our control by sending an email to our Personal
          Data Protection Officer and we will process such requests in
          accordance with this Privacy Policy and our obligations under the
          Privacy Laws and other applicable laws. However, your withdrawal of
          consent may mean that we will not be able to continue providing the
          Services to you and we may need to terminate your existing
          relationship and/or the contract you have with us.
        </div>
        <div className="pp-descrip">
          <strong>12.1.2</strong> - Once we have your clear withdrawal
          instructions and verified your identity, we will process your request
          for withdrawal of consent, and will thereafter not collect, use and/or
          disclose your personal data in the manner stated in your request. If
          we are unable to verify your identity or understand your instructions,
          we will liaise with you to understand your request.
        </div>
        <div className="pp-descrip">
          <strong>12.1.3</strong> - However, your withdrawal of consent could
          result in certain legal consequences arising from such withdrawal. In
          this regard, depending on the extent of your withdrawal of consent for
          us to process your personal data, it may mean that we will not be able
          to continue providing the Services to you, we may need to terminate
          your existing relationship and/or the contract you have with us, etc.,
          as the case may be, which we will inform you of.
        </div>
        <div className="pp-descrip">
          <strong>12.2</strong> - Requesting Access and/or Correction of
          Personal Data
        </div>
        <div className="pp-descrip">
          <strong>12.2.1</strong> - If you have an account with us, you may
          personally access and/or correct your personal data currently in our
          possession or control through the Account Settings page of the Site.
          If you do not have an account with us, you may request to access
          and/or correct your personal data currently in our possession or
          control by submitting a written request to us. We will need enough
          information from you in order to ascertain your identity as well as
          the nature of your request so as to be able to deal with your request.
          Hence, please submit your written request by sending an email to our
          Personal Data Protection Officer (customerservice@unity.net.my)
        </div>
        <div className="pp-descrip">
          <strong>12.2.2</strong> - For a request to access personal data, once
          we have sufficient information from you to deal with the request, we
          will seek to provide you with the relevant personal data within 30
          days (or, if you are resident in Malaysia, 21 days). Where we are
          unable to respond to you within the 30 days (or, if you are resident
          in Malaysia, 21 days), we will notify you of the soonest possible time
          within which we can provide you with the information requested. Note
          that Privacy Laws may exempt certain types of personal data from being
          subject to your access request.
        </div>
        <div className="pp-descrip">
          <strong>12.2.3</strong> - For a request to correct personal data, once
          we have sufficient information from you to deal with the request, we
          will:
          <br />
          (a) Correct your personal data within 30 days (or, if you are resident
          in Malaysia, 21 days). Where we are unable to do so within the said
          period, we will notify you of the soonest practicable time within
          which we can make the correction. Note that Privacy Laws may exempt
          certain types of personal data from being subject to your correction
          request.
          <br />
          (a) Correct your personal data within 30 days (or, if you are resident
          in Malaysia, 21 days). Where we are unable to do so within the said
          period, we will notify you of the soonest practicable time within
          which we can make the correction. Note that Privacy Laws may exempt
          certain types of personal data being subject to your correction
          request as well as provides for situations(s) when correction need not
          be made by us despite your request, and
          <br />
          (b) We will send the corrected personal data to every other
          organisation to which the personal data was disclosed by us within a
          year before the date correction was made, unless that other
          organisation does not need the corrected personal data for any legal
          or business purpose.
        </div>
        <div className="pp-descrip">
          <strong>12.2.4</strong> - Notwithstanding sub-paragraph (b)
          immediately above, we may, if you so request, send the corrected
          personal data only to specific organisations to which the personal
          data was disclosed by us within a year before the correction was made.
        </div>
        <div className="pp-descrip">
          <strong>12.2.5</strong> - We will/may also be charging you a
          reasonable fee for the handling and processing of your requests to
          access your personal data. If we so choose to charge, we will provide
          you with a written estimate of the fee we will be charging. Please
          note that we are not required to respond to or deal with your access
          request unless you have agreed to pay the fee.
        </div>
        <div className="pp-descrip">
          <strong>12.2.6</strong> - We reserve the right to refuse to correct
          your personal data in accordance with the provisions as set out in
          Privacy Laws, where they require and/or entitle an organisation to
          refuse to correct personal data in stated circumstances.
        </div>

        <div className="pp-subtitle">
          13. QUESTIONS, CONCERNS OR COMPLAINTS? CONTACT US
        </div>
        <div className="pp-descrip">
          <strong>13.1</strong> - If you have any questions or concerns about
          our privacy practices or your dealings with the Services, please do
          not hesitate to contact: customerservice@unity.net.my
        </div>
        <div className="pp-descrip">
          <strong>13.2</strong> - If you have any complaint or grievance
          regarding how we are handling your personal data or about how we are
          complying with Privacy Laws, we welcome you to contact us with your
          complaint or grievance.
          <br />
          Please contact us via email with your complaint or grievance :
          <br />
          Email : customerservice@unity.net.my and Attention it to the “Personal
          Data Protection Officer”.
          <br />
          Please send all legal notices to legal.my@unity.net.my and Attention
          it to the “General Counsel”.
        </div>
        <div className="pp-descrip">
          <strong>13.3</strong> - Where it is an email or a letter through which
          you are submitting a complaint, your indication at the subject header
          that it is a Privacy Law complaint would assist us in attending to
          your complaint speedily by passing it on to the relevant staff in our
          organisation to handle. For example, you could insert the subject
          header as “Privacy Complaint”.
          <br />
          We will certainly strive to deal with any complaint or grievance that
          you may have fairly and as soon as possible.
        </div>

        <div className="pp-subtitle">14. TERMS AND CONDITIONS</div>
        <div className="pp-descrip">
          Please also read the Terms of Service establishing the use,
          disclaimers, and limitations of liability governing the use of the
          Site and the Services and other related policies.
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
